var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcStatesHealth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.27802 5.57087C8.9394 5.26766 9.39997 4.58969 9.39997 3.80198C9.39997 2.73149 8.54939 1.8637 7.50015 1.8637C6.4509 1.8637 5.60033 2.73149 5.60033 3.80198C5.60033 4.56602 6.03362 5.2268 6.66319 5.54252C5.65713 6.03536 4.34399 6.69161 3.28189 7.57225C3.14332 7.68715 3.06716 7.85955 3.06716 8.03956C3.06716 8.43206 3.42196 8.72916 3.80836 8.6602L5.81906 8.30138L4.33605 12.8405C4.17879 13.3218 4.53747 13.8163 5.04383 13.8163C5.48442 13.8163 5.88383 13.5573 6.06357 13.155L7.50023 9.93975L8.78011 13.0736C8.96354 13.5228 9.40047 13.8163 9.88562 13.8163C10.427 13.8163 10.8105 13.2876 10.6424 12.773L9.18141 8.30143L11.1325 8.64962C11.5498 8.72409 11.933 8.40324 11.933 7.97936C11.933 7.78763 11.8533 7.60342 11.7057 7.48101C10.6788 6.62909 9.38068 6.05468 8.27802 5.57087Z",
    fill: "#0A0A0A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStatesHealth);
export default __webpack_public_path__ + "static/media/ic_states_health.da00cca7c65729994bc2cf3b165df0fd.svg";
export { ForwardRef as ReactComponent };